// extracted by mini-css-extract-plugin
module.exports = {"main":"Password_main__FQ7FR","form-field":"Password_form-field__2o2bV"};